var zipCodes = ['2000','2004','2006','2007','2008','2009','2010','2011','2012','2015','2016','2017','2018','2019','2020','2021','2022','2023','2024','2025','2026','2027','2028','2029','2030','2031','2032','2033','2034','2035','2036','2037','2038','2039','2040','2041','2042','2043','2044','2045','2046','2047','2048','2049','2050','2052','2055','2057','2058','2060','2061','2062','2063','2064','2065','2066','2067','2068','2069','2070','2071','2072','2073','2074','2075','2076','2077','2079','2080','2081','2082','2083','2084','2085','2086','2087','2088','2089','2090','2091','2092','2093','2094','2095','2096','2097','2099','2100','2101','2102','2103','2104','2105','2106','2107','2108','2109','2110','2111','2112','2113','2114','2115','2116','2117','2118','2119','2120','2121','2122','2123','2125','2126','2127','2128','2129','2130','2131','2132','2133','2134','2135','2136','2137','2138','2139','2140','2141','2142','2143','2144','2145','2146','2147','2148','2150','2151','2152','2153','2154','2155','2156','2157','2158','2159','2160','2161','2162','2163','2164','2165','2166','2167','2168','2170','2171','2172','2173','2174','2175','2176','2177','2178','2179','2190','2191','2192','2193','2194','2195','2196','2197','2198','2199','2200','2203','2204','2205','2206','2207','2208','2209','2210','2211','2212','2213','2214','2216','2217','2218','2219','2220','2221','2222','2223','2224','2225','2226','2227','2228','2229','2230','2231','2232','2233','2234','2557','2560','2563','2564','2565','2566','2567','2568','2569','2570','2745','2747','2748','2749','2750','2752','2753','2754','2756','2757','2758','2759','2760','2761','2762','2763','2765','2766','2767','2768','2769','2770','2013','2051','2078','2124','2149','2169','2555','2556','2558','2559','2250','2251','2252','2256','2257','2258','2259','2260','2261','2262','2263','2773','2774','2775','2776','2777','2778','2779','2780','2782','2783','2785','2784','2786','2787','2600','2601','2602','2603','2604','2605','2606','2607','2609','2611','2612','2614','2615','2617','2618','2900','2902','2903','2904','2905','2906','2580','2620','2610','2616','2620','2621','2622','2582','2280','2282','2283','2284','2285','2286','2287','2289','2290','2291','2292','2293','2294','2295','2296','2297','2298','2299','2300','2302','2303','2304','2305','2306','2307','2308','2311','2312','2320','2321','2322','2323','2324','2325','2326','2327','2328','2329','2330','2333','2334','2335','2336','2337','2338','2339','2264','2265','2267','2278','2281','2315','2316','2317','2318','2319','2321','2322','2323','2324','2325','2326','2327','2328','2331','2415','2420','2421','2422','2423','2424','2425','2426','2427','2428','2429','2430','2439','2443','2428','2429','2430','2431','2575','2576','2577','2578','2579','2571','2572','2573','2500','2502','2505','2506','2508','2515','2516','2517','2518','2519','2522','2525','2526','2527','2528','2529','2533','2534','2536','2537','2538','2540','2541','2542','2543','2544','2545','2546','2548','2549','2550','2551','2535','2539','2790','2795','2800','3000','3001','3002','3003','3004','3005','3006','3008','3011','3012','3013','3015','3016','3018','3019','3020','3021','3022','3023','3024','3025','3026','3027','3028','3029','3030','3031','3032','3033','3034','3036','3037','3038','3040','3041','3042','3043','3044','3045','3046','3047','3048','3049','3050','3051','3052','3053','3054','3055','3056','3057','3058','3060','3061','3062','3063','3064','3065','3066','3067','3068','3070','3071','3072','3073','3074','3075','3076','3081','3082','3083','3084','3085','3086','3087','3101','3102','3103','3104','3105','3106','3107','3108','3109','3111','3113','3114','3115','3116','3121','3122','3123','3124','3125','3126','3127','3128','3129','3130','3131','3132','3133','3134','3135','3136','3137','3138','3141','3142','3143','3144','3145','3146','3147','3148','3149','3150','3151','3152','3153','3154','3155','3156','3161','3162','3163','3164','3165','3166','3167','3168','3169','3170','3171','3172','3173','3174','3175','3181','3182','3183','3184','3185','3186','3187','3188','3189','3190','3191','3192','3193','3194','3195','3196','3197','3198','3199','3335','3337','3338','3340','3427','3428','3429','3752','3754','3755','3756','3757','3802','3803','3804','3805','3806','3807','3808','3809','3810','3812','3813','3814','3815','4000','4005','4006','4007','4008','4009','4010','4011','4012','4013','4014','4017','4018','4019','4020','4021','4022','4030','4031','4032','4034','4035','4036','4037','4038','4039','4051','4053','4054','4055','4059','4060','4061','4064','4065','4066','4067','4068','4069','4070','4071','4072','4073','4074','4075','4101','4102','4103','4104','4105','4106','4107','4108','4109','4110','4111','4112','4113','4114','4115','4116','4120','4121','4122','4123','4124','4125','4127','4151','4152','4153','4154','4155','4156','4157','4169','4170','4171','4172','4173','4174','4178','4205','4025','4029','4128','4129','4130','4131','4132','4133','4179','4207','4208','4209','4300','4301','4303','4304','4305','4306']
$(document).ready(function() {

  function createDraftOrder(fname = '', email = '',date = '',zip = '',phone = '',address1 = '',city = '',province = '',uv = '',pickup = false){
    $.getJSON('/cart.js', function(cartData) {
      // date and time must be defined before this
      // e.g. var date = '2025-11-22'; var time = '10:00 AM';
      const line_items = cartData.items.map(function (item) {
          let itemObject = {}
          if(item.line_level_discount_allocations.length > 0){
              itemObject.variant_id = item.variant_id
              itemObject.quantity = item.quantity
              itemObject.price = item.final_price
              itemObject.applied_discount = {
                description: item.line_level_discount_allocations[0].discount_application.title,
                value_type: item.line_level_discount_allocations[0].discount_application.value_type,
                value: item.line_level_discount_allocations[0].discount_application.value,
                amount: item.line_level_discount_allocations[0].amount,
                title: item.line_level_discount_allocations[0].discount_application.title
              }
              if(date){
                itemObject.properties = [
                  {
                      name:'Pickup Date',
                      value: date,
                  }
                ]
              }
              return itemObject;
          }else{
            itemObject.variant_id = item.variant_id
            itemObject.quantity = item.quantity
            itemObject.price = item.final_price
            if(date){
              itemObject.properties = [
                {
                    name:'Pickup Date',
                    value: date,
                }
              ]
            }
            return itemObject;
          }
      });
      const address = {
        country:'Australia',
      };
      if(fname){
        address.first_name = fname
      }
      if(zip){
        address.zip = zip
      }
      if (address1) {
        address.address1 = address1
      }
      if (city) {
        address.city = city
      }
      if (province) {
        address.province = province
      }
      const phonePattern = /^[0-9\s+\-()]{8,15}$/; 
      if (phone && phonePattern.test(phone)) {
        address.phone = phone
      }
      let payload = {
        email,
        line_items,
        shipping_address: address,
        tags:'Abandoned Cart - Follow Up',
        send_email:false,
        apply_pickup:pickup,
        local_delivery:false
      };
      const draftNoteLines = [];
      if(uv){
        draftNoteLines.push(uv)
      }
      if(date){
        draftNoteLines.push(`Pickup Date: ${date}`)
      }
      const draftNote = buildOrderNote(cartData.note, draftNoteLines)
      if(draftNote){
        payload.note = draftNote
      }

      // Call Draft Order API
      $.ajax({
        url: "https://flooring-shipping-app.vercel.app/api/draft-order",
        // url: "https://4619d3949a08.ngrok-free.app/api/draft-order",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(payload),
        success: function (res) {
          if (res.success) {
            localStorage.setItem('draft_order_email',email)
            localStorage.setItem('draft_order_id',res.draft_order.id)
            console.log(res)
            console.log(res.success)
          } else {
              // $('.xtra-loader-wrapper').fadeOut(500)
              console.log(res.error)
              // window.location.href = '/checkout'
          }
        },
        error: function (xhr, status, error) {
            // $('.xtra-loader-wrapper').fadeOut(500)
            console.error(error);
            // window.location.href = '/checkout'
        },
        complete: function () {
            console.log('complete')
            // $("#xtra-quote-submit").prop("disabled", false);
        }
      });
    });
  }

  function buildCartBuyerIdentityPayload(cartData, options = {}) {
    console.log('cartData')
    console.log(cartData)
    console.log('options',options)
    if (!cartData || !cartData.token || !options.email) {
      return null;
    }

    const countryCode = options.countryCode || "AU";
    const payload = {
      cartId: `gid://shopify/Cart/${cartData.token}`,
      buyerIdentity: {
        email: options.email,
        countryCode,
        preferences: {
          delivery: {
            deliveryMethod: options.deliveryMethod || "SHIPPING",
          },
        },
      },
      addresses: [
        {
          selected: true,
          address: {
            deliveryAddress: {
              // firstName: options.firstName,
              // address1: options.address1 || "38 Martin Place",
              // city: options.city || "Sydney",
              // provinceCode: options.provinceCode || "NSW",
              countryCode,
              // zip: options.zip || "2000",
            },
          },
        },
      ],
    };

    if (options.deliveryMethod == 'PICK_UP') {
      payload.pickupDate = options.pickupDate;
      payload.line_items = options.line_items;
    }
    if (options.phone) {
      payload.buyerIdentity.phone = `+61${options.phone}`;
      payload.addresses[0].address.deliveryAddress.phone = `+61${options.phone}`;
    }
    if (options.address1) {
      payload.addresses[0].address.deliveryAddress.address1 = options.address1;
    }
    if (options.city) {
      payload.addresses[0].address.deliveryAddress.city = options.city;
    }
    if (options.provinceCode) {
      payload.addresses[0].address.deliveryAddress.provinceCode = options.provinceCode;
    }
    if (options.zip) {
      payload.addresses[0].address.deliveryAddress.zip = options.zip;
    }
    if (options.firstName) {
      payload.addresses[0].address.deliveryAddress.firstName = options.firstName;
    }
    if (options.note) {
      payload.note = options.note;
    }

    return payload;
  }

  function getCheckoutUrlFromBuyerIdentityResponse(res) {
    if (
      res &&
      res.success &&
      res.buyerIdentityUpdate &&
      res.buyerIdentityUpdate.cart &&
      res.buyerIdentityUpdate.cart.checkoutUrl
    ) {
      return res.buyerIdentityUpdate.cart.checkoutUrl;
    }
    return null;
  }

  function redirectToCheckoutOrFallback(res) {
    console.log(res)
    const checkoutUrl = getCheckoutUrlFromBuyerIdentityResponse(res);
    if (checkoutUrl) {
      window.location.href = checkoutUrl;
    } else {
      console.log('checkoutUrl',checkoutUrl)
      // window.location.href = '/checkout';
    }
  }

  const DELIVERY_TYPE_NOTE_PREFIX = 'Delivery Type(s):';

  function getSelectedDeliveryTypes() {
    return $('input[name="xtra_delivery_type"]:checked').map(function () {
      return $(this).val();
    }).get();
  }

  function buildDeliveryTypeNoteLine(deliveryTypes = getSelectedDeliveryTypes()) {
    if (!deliveryTypes.length) {
      return '';
    }
    return `${DELIVERY_TYPE_NOTE_PREFIX} ${deliveryTypes.join('; ')}`;
  }

  function removeGeneratedDeliveryTypeLine(note = '') {
    return String(note || '')
      .split(/\r?\n/)
      .filter(function (line) {
        return !line.trim().startsWith(DELIVERY_TYPE_NOTE_PREFIX);
      })
      .join('\n')
      .trim();
  }

  function buildOrderNote(existingNote = '', generatedLines = []) {
    const preservedNote = removeGeneratedDeliveryTypeLine(existingNote);
    const normalizedLines = [];

    generatedLines.forEach(function (line) {
      if (!line) return;
      String(line).split(/\r?\n/).forEach(function (noteLine) {
        const trimmedLine = noteLine.trim();
        if (trimmedLine) {
          normalizedLines.push(trimmedLine);
        }
      });
    });

    return [preservedNote].concat(normalizedLines).filter(Boolean).join('\n');
  }

  function buildQuoteDraftNote(fname = '', unloadingValue = '', deliveryTypes = getSelectedDeliveryTypes()) {
    const noteLines = [];
    if (fname) {
      noteLines.push(`Quote requested by ${fname}`);
    }
    const deliveryTypeNoteLine = buildDeliveryTypeNoteLine(deliveryTypes);
    if (deliveryTypeNoteLine) {
      noteLines.push(deliveryTypeNoteLine);
    }
    if (unloadingValue) {
      noteLines.push(`Unloading Option: ${unloadingValue}`);
    }
    return noteLines.join('\n');
  }

  function setDeliveryTypeError(message = '') {
    const $error = $('#xtra-delivery-type-error');
    const $inputs = $('input[name="xtra_delivery_type"]');
    $inputs.attr('aria-invalid', message ? 'true' : 'false');
    if (message) {
      $error.text(message).fadeIn(300);
    } else {
      $error.text('').hide();
    }
  }

  function updateDeliveryTypeSelectionState() {
    const selectedCount = getSelectedDeliveryTypes().length;
    const limitReached = selectedCount >= 2;

    $('input[name="xtra_delivery_type"]').each(function () {
      const shouldDisable = limitReached && !this.checked;
      $(this)
        .prop('disabled', shouldDisable)
        .closest('.xtra-delivery-type-option')
        .toggleClass('is-disabled', shouldDisable);
    });
  }

  function validateDeliveryTypes() {
    const selectedCount = getSelectedDeliveryTypes().length;
    if (selectedCount === 0) {
      setDeliveryTypeError('Please select at least one delivery type.');
      return false;
    }
    if (selectedCount > 2) {
      setDeliveryTypeError('Please select no more than 2 delivery types.');
      return false;
    }
    setDeliveryTypeError();
    return true;
  }

  $(document).on('change', 'input[name="xtra_delivery_type"]', function () {
    if (getSelectedDeliveryTypes().length > 2) {
      $(this).prop('checked', false);
      setDeliveryTypeError('Please select no more than 2 delivery types.');
    } else {
      setDeliveryTypeError();
    }
    updateDeliveryTypeSelectionState();
  });

  updateDeliveryTypeSelectionState();

  $('#xtra-quote-zip').on('keyup', function () {
      let value = $(this).val();

      // Remove non-digits
      value = value.replace(/\D/g, '');

      // Limit to 4 digits
      if (value.length > 4) {
          value = value.slice(0, 4);
      }

      $(this).val(value);
  });
  /* ---------------------------
    Unloading Option Change
  ---------------------------- */

  jQuery(document).on('change','label.xtra-unloading-option-label input[type="radio"]',function(){
    console.log(jQuery('label.xtra-unloading-option-label input[type="radio"]:checked').val())
    if(jQuery('label.xtra-unloading-option-label input[type="radio"]:checked').val() == 'Other (please specify):' ){
        jQuery('input#xtra-unloading-other').slideDown(500)
    }else{
        jQuery('input#xtra-unloading-other').slideUp(500)
    }
  })
  /* ---------------------------
    Date Validation
  ---------------------------- */
  $(document).on('change', '#xtra-pickup-date', function () {
    let val = $(this).val();
    if (!val) return;

    let date = new Date(val);
    let day = date.getUTCDay(); // 0 = Sunday

    if (day === 0) {
      $(this).val(""); // reset the date
      $('#pickup_error_lable').html("Sundays are not allowed. Please select a different date.")
      $('#pickup_error_lable').fadeIn(300)
    }else{
      $('#pickup_error_lable').html("")
      $('#pickup_error_lable').fadeOut(300)
    }
  });
  /* ---------------------------
    Show / Hide Forms on Option Select
  ---------------------------- */
  $(document).on('change','input[name="xtra_option"]', function () {

      if ($(this).val() === 'pickup') {
        $('#xtra-pickup-form').slideDown();
        $('#xtra-quote-form').slideUp();
        setTimeout(() => {
          $('html').animate({scrollTop: $('#xtra-pickup-form').offset().top},800);
        },600)
      } else if ($(this).val() === 'quote') {
        $('#xtra-pickup-form').slideUp();
        if($('.line-item[data-product-type="Main Product"]').length > 0){
            $('#xtra-quote-form').slideDown();
            setTimeout(() => {
                $('html').animate({scrollTop: $('#xtra-quote-form').offset().top - 200},800);
            },600)
        }else{
            window.location.href = '/checkout'
        }
      }
  });

  /* ---------------------------
    Capture data
  ---------------------------- */
  let typingTimer
  let changeTimer
  let loadingChangeTimer
  let addressTypingTimer
  const delay = 4500
  $(document).on('keyup','#xtra-pickup-email,#xtra-pickup-first-name', function(){
    const date = $('#xtra-pickup-date').val();
    const email = $("#xtra-pickup-email").val().trim();
    const fname = $("#xtra-pickup-first-name").val().trim();

    console.log('Email changed')
    clearTimeout(typingTimer);
    clearTimeout(changeTimer);
    clearTimeout(loadingChangeTimer);
    clearTimeout(addressTypingTimer);
    typingTimer = setTimeout(function () {
      // ✅ USER STOPPED TYPING — DO YOUR ACTION HERE
      console.log('User stopped typing:', email);

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email || !emailPattern.test(email)) {
        console.log('email is invalid or empty');
        return;
      }
      let draftOrderId = localStorage.getItem('draft_order_id')
      let draftOrderEmail = localStorage.getItem('draft_order_email')
      if(!draftOrderId){
        console.log('no id found')
        createDraftOrder(fname,email,date,'','','','','',"Pickup order",true)
      }else if(draftOrderId){
        $.ajax({
          url: "https://flooring-shipping-app.vercel.app/api/draft-order-delete",
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({id:draftOrderId}),
          success: function (res) {
            if (res.success) {
                console.log(res)
                console.log(res.success)
                localStorage.removeItem('draft_order_email');
                localStorage.removeItem('draft_order_id');
                createDraftOrder(fname,email,date,'','','','','',"Pickup order",true);
            } else {
              console.log(res.error)
            }
          },
          error: function (xhr, status, error) {
            console.log('Status Code:', xhr.status);          // e.g. 400, 401, 500
            console.log('Status Text:', xhr.statusText);      // e.g. "Bad Request"
            console.log('Error:', error);                  // e.g. "Internal Server Error"

            let message = '';
            if (xhr.responseJSON) {
                message = xhr.responseJSON.message || xhr.responseJSON.error || JSON.stringify(xhr.responseJSON);
            } else if (xhr.responseText) {
                message = xhr.responseText;
            } else {
                message = error || 'Unknown error occurred';
            }
            console.log('message',message)
            if(xhr.status == 500){
              localStorage.removeItem('draft_order_email');
              localStorage.removeItem('draft_order_id');
              createDraftOrder(fname,email,date,'','','','','',"Pickup order",true);
            }
          }
        });
      }
    }, delay);
  })
    $(document).on('change','#xtra-pickup-date', function(){
      const date = $('#xtra-pickup-date').val();
      const email = $("#xtra-pickup-email").val().trim();
      const fname = $("#xtra-pickup-first-name").val().trim();

      console.log('Email changed')
      clearTimeout(typingTimer);
      clearTimeout(changeTimer);
      clearTimeout(loadingChangeTimer);
      clearTimeout(addressTypingTimer);
      changeTimer = setTimeout(function () {
        // ✅ USER STOPPED TYPING — DO YOUR ACTION HERE
        console.log('User stopped typing:', email);

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailPattern.test(email)) {
          console.log('email is invalid or empty');
          return;
        }
        let draftOrderId = localStorage.getItem('draft_order_id')
        let draftOrderEmail = localStorage.getItem('draft_order_email')
        if(!draftOrderId){
          console.log('no id found')
          createDraftOrder(fname,email,date,'','','','','',"Pickup order",true)
        }else if(draftOrderId){
          $.ajax({
            url: "https://flooring-shipping-app.vercel.app/api/draft-order-delete",
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({id:draftOrderId}),
            success: function (res) {
              if (res.success) {
                  console.log(res)
                  console.log(res.success)
                  localStorage.removeItem('draft_order_email');
                  localStorage.removeItem('draft_order_id');
                  createDraftOrder(fname,email,date,'','','','','',"Pickup order",true);
              } else {
                console.log(res.error)
              }
            },
            error: function (xhr, status, error) {
              console.log('Status Code:', xhr.status);          // e.g. 400, 401, 500
              console.log('Status Text:', xhr.statusText);      // e.g. "Bad Request"
              console.log('Error:', error);                  // e.g. "Internal Server Error"

              let message = '';
              if (xhr.responseJSON) {
                  message = xhr.responseJSON.message || xhr.responseJSON.error || JSON.stringify(xhr.responseJSON);
              } else if (xhr.responseText) {
                  message = xhr.responseText;
              } else {
                  message = error || 'Unknown error occurred';
              }
              console.log('message',message)
              if(xhr.status == 500){
                localStorage.removeItem('draft_order_email');
                localStorage.removeItem('draft_order_id');
                createDraftOrder(fname,email,date,'','','','','',"Pickup order",true);
              }
            }
          });
        }
      }, delay);
    })
    $(document).on('keyup','#xtra-quote-email,#xtra-quote-first-name,#xtra-quote-zip,#xtra-quote-phone,#xtra-quote-address-line1,#xtra-quote-city,#xtra-quote-state', function(){
      const email = $("#xtra-quote-email").val().trim();
      const fname = $("#xtra-quote-first-name").val().trim();

      const phone = $("#xtra-quote-phone").val().trim(); // NEW PHONE FIELD
      const address1 = $("#xtra-quote-address-line1").val().trim();
      const city = $("#xtra-quote-city").val().trim();
      const province = $("#xtra-quote-state").val().trim();

      const zip = $("#xtra-quote-zip").val().trim();
      const country = "Australia";
      const unloadingOption = jQuery('label.xtra-unloading-option-label input[type="radio"]:checked').val()
      let unloadingValue = ''

      clearTimeout(typingTimer);
      clearTimeout(changeTimer);
      clearTimeout(loadingChangeTimer);
      clearTimeout(addressTypingTimer);

      addressTypingTimer = setTimeout(function () {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailPattern.test(email)) {
          console.log('email is invalid or empty');
          return;
        }
        if(unloadingOption && unloadingOption == 'Other (please specify):'){
          if(jQuery('input#xtra-unloading-other').val()){
            unloadingValue = jQuery('input#xtra-unloading-other').val()
          }else{
            unloadingValue = ''
          }
        }else if(unloadingOption){
          unloadingValue = unloadingOption
        }else{
          unloadingValue = ''
        }
        let draftOrderId = localStorage.getItem('draft_order_id')
        let draftOrderEmail = localStorage.getItem('draft_order_email')

        if(!draftOrderId){
          console.log('no id found')
          createDraftOrder(fname,email,'',zip,phone,address1,city,province,buildQuoteDraftNote(fname, unloadingValue),false)
        }else if(draftOrderId){
          $.ajax({
            url: "https://flooring-shipping-app.vercel.app/api/draft-order-delete",
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({id:draftOrderId}),
            success: function (res) {
              if (res.success) {
                  console.log(res)
                  console.log(res.success)
                  localStorage.removeItem('draft_order_email');
                  localStorage.removeItem('draft_order_id');
                  createDraftOrder(fname,email,'',zip,phone,address1,city,province,buildQuoteDraftNote(fname, unloadingValue),false);
              } else {
                  console.log(res.error)
              }
            },
            error: function (xhr, status, error) {
              console.log('Status Code:', xhr.status);          // e.g. 400, 401, 500
              console.log('Status Text:', xhr.statusText);      // e.g. "Bad Request"
              console.log('Error:', error);                  // e.g. "Internal Server Error"
              
              let message = '';
              if (xhr.responseJSON) {
                  message = xhr.responseJSON.message || xhr.responseJSON.error || JSON.stringify(xhr.responseJSON);
              } else if (xhr.responseText) {
                  message = xhr.responseText;
              } else {
                  message = error || 'Unknown error occurred';
              }
              console.log('message',message)

              if(xhr.status == 500){
                localStorage.removeItem('draft_order_email');
                localStorage.removeItem('draft_order_id');
                createDraftOrder(fname,email,'',zip,phone,address1,city,province,buildQuoteDraftNote(fname, unloadingValue),false);
              }
            }
          });
        }
      },delay)
    })
    $(document).on('change','label.xtra-unloading-option-label input[type="radio"], input[name="xtra_delivery_type"]', function(){
      const email = $("#xtra-quote-email").val().trim();
      const fname = $("#xtra-quote-first-name").val().trim();

      const phone = $("#xtra-quote-phone").val().trim(); // NEW PHONE FIELD
      const address1 = $("#xtra-quote-address-line1").val().trim();
      const city = $("#xtra-quote-city").val().trim();
      const province = $("#xtra-quote-state").val().trim();

      const zip = $("#xtra-quote-zip").val().trim();
      const country = "Australia";
      const unloadingOption = jQuery('label.xtra-unloading-option-label input[type="radio"]:checked').val()
      let unloadingValue = ''

      clearTimeout(typingTimer);
      clearTimeout(changeTimer);
      clearTimeout(loadingChangeTimer);
      clearTimeout(addressTypingTimer);

      loadingChangeTimer = setTimeout(function () {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailPattern.test(email)) {
          console.log('email is invalid or empty');
          return;
        }
        if(unloadingOption && unloadingOption == 'Other (please specify):'){
          if(jQuery('input#xtra-unloading-other').val()){
            unloadingValue = jQuery('input#xtra-unloading-other').val()
          }else{
            unloadingValue = ''
          }
        }else if(unloadingOption){
          unloadingValue = unloadingOption
        }else{
          unloadingValue = ''
        }
        let draftOrderId = localStorage.getItem('draft_order_id')
        let draftOrderEmail = localStorage.getItem('draft_order_email')

        if(!draftOrderId){
          console.log('no id found')
          createDraftOrder(fname,email,'',zip,phone,address1,city,province,buildQuoteDraftNote(fname, unloadingValue),false)
        }else if(draftOrderId){
          $.ajax({
            url: "https://flooring-shipping-app.vercel.app/api/draft-order-delete",
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({id:draftOrderId}),
            success: function (res) {
              if (res.success) {
                  console.log(res)
                  console.log(res.success)
                  localStorage.removeItem('draft_order_email');
                  localStorage.removeItem('draft_order_id');
                  createDraftOrder(fname,email,'',zip,phone,address1,city,province,buildQuoteDraftNote(fname, unloadingValue),false)
              } else {
                  console.log(res.error)
              }
            },
            error: function (xhr, status, error) {
              console.log('Status Code:', xhr.status);          // e.g. 400, 401, 500
              console.log('Status Text:', xhr.statusText);      // e.g. "Bad Request"
              console.log('Error:', error);                  // e.g. "Internal Server Error"
              
              let message = '';
              if (xhr.responseJSON) {
                  message = xhr.responseJSON.message || xhr.responseJSON.error || JSON.stringify(xhr.responseJSON);
              } else if (xhr.responseText) {
                  message = xhr.responseText;
              } else {
                  // Fallback
                  message = error || 'Unknown error occurred';
              }
              console.log('message',message)

              if(xhr.status == 500){
                localStorage.removeItem('draft_order_email');
                localStorage.removeItem('draft_order_id');
                createDraftOrder(fname,email,'',zip,phone,address1,city,province,buildQuoteDraftNote(fname, unloadingValue),false)
              }
            }
          });
        }
      },delay)
    })

    /* ---------------------------
      Set Minimum Date to Today
    ---------------------------- */
    const today = new Date().toISOString().split("T")[0];
    $("#xtra-pickup-date").attr("min", today);

    /* ---------------------------
      Submit Sydney Pick Up Form
    ---------------------------- */
    $(document).on('click','#xtra-pickup-submit', function () {
      $('#pickup_error_lable').html("")
      $('#pickup_error_lable').fadeOut(300)
      const date = $('#xtra-pickup-date').val();
      const email = $("#xtra-pickup-email").val().trim();
      const fname = $("#xtra-pickup-first-name").val().trim();

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email) {
        $('#error_lable').html("Email address is required.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      }else if(!emailPattern.test(email)){
        $('#error_lable').html("Please enter a valid email address.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      
      }
      if (!date) {
          $('#pickup_error_lable').html('Please select both date and time')
          $('#pickup_error_lable').fadeIn(300)
          return;
      }
      if (!fname) {
          $('#pickup_error_lable').html('First Name is required')
          $('#pickup_error_lable').fadeIn(300)
          return;
      }
      $('.xtra-loader-wrapper').fadeIn(500)
      let draftOrderId = localStorage.getItem('draft_order_id')
      let draftOrderEmail = localStorage.getItem('draft_order_email')
      clearTimeout(typingTimer);
      clearTimeout(changeTimer);
      clearTimeout(loadingChangeTimer);
      clearTimeout(addressTypingTimer);
      if(draftOrderId){
        $.ajax({
          url: "https://flooring-shipping-app.vercel.app/api/draft-order-delete",
          // url: "https://83a72a5001a2.ngrok-free.app/api/draft-order-delete",
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({id:draftOrderId}),
          success: function (res) {
            if (res.success) {
                console.log(res)
                console.log(res.success)
                localStorage.removeItem('draft_order_email');
                localStorage.removeItem('draft_order_id');
                $.getJSON('/cart.js', function(cartData) {
                  const line_items = cartData.items.map(function (item) {
                    return {
                      variant_id: item.variant_id,
                      properties: [
                          {
                              name:'Pickup Date',
                              value: date,
                          }
                      ]
                    }
                  });

                  const cartBuyerIdentityPayload = buildCartBuyerIdentityPayload(cartData, {
                    email,
                    note: `Pickup order\nPickup Date: ${date}`,
                    line_items,
                    firstName: fname,
                    countryCode: "AU",
                    deliveryMethod: "PICK_UP",
                    pickupHandle:'64304775340',
                    pickupDate:date
                  });
                  console.log('cartBuyerIdentityPayload',cartBuyerIdentityPayload)

                  $.ajax({
                    // url: "https://e290-116-90-106-53.ngrok-free.app/api/cart-buyer-identity-update",
                    url: "https://flooring-shipping-app.vercel.app/api/cart-buyer-identity-update",
                    method: "POST",
                    contentType: "application/json",
                    data: JSON.stringify(cartBuyerIdentityPayload),
                    success: function (res) {
                      $('.xtra-loader-wrapper').fadeOut(500)
                      if (res.success) {
                        redirectToCheckoutOrFallback(res)
                      } else {
                        console.log(res.error || res.userErrors)
                        console.log('res of error')
                        console.log(res)
                        // window.location.href = '/checkout'
                      }
                    },
                    error: function (xhr, status, error) {
                      $('.xtra-loader-wrapper').fadeOut(500)
                      console.error(error);
                      // window.location.href = '/checkout'
                    },
                    complete: function () {
                      $('.xtra-loader-wrapper').fadeOut(500)
                      $("#xtra-quote-submit").prop("disabled", false);
                    }
                  });
                });
            } else {
                $('.xtra-loader-wrapper').fadeOut(500)
                console.log(res.error)
                window.location.href = '/checkout'
            }
          },
          error: function (xhr, status, error) {
              $('.xtra-loader-wrapper').fadeOut(500)
              console.error(error);
              window.location.href = '/checkout'
          }
        });
      }else{
        $.getJSON('/cart.js', function(cartData) {
          // date and time must be defined before this
          // e.g. var date = '2025-11-22'; var time = '10:00 AM';
          const line_items = cartData.items.map(function (item) {
            return {
              variant_id: item.variant_id,
              properties: [
                  {
                      name:'Pickup Date',
                      value: date,
                  }
              ]
            }
          });
  
          const cartBuyerIdentityPayload = buildCartBuyerIdentityPayload(cartData, {
            email,
            note: `Pickup order\nPickup Date: ${date}`,
            line_items,
            firstName: fname,
            countryCode: "AU",
            deliveryMethod: "PICK_UP",
            pickupHandle:'64304775340',
            pickupDate:date
          });

          if (!cartBuyerIdentityPayload) {
            $('.xtra-loader-wrapper').fadeOut(500)
            window.location.href = '/checkout'
            return;
          }

          $.ajax({
            // url: "https://e290-116-90-106-53.ngrok-free.app/api/cart-buyer-identity-update",
            url: "https://flooring-shipping-app.vercel.app/api/cart-buyer-identity-update",
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(cartBuyerIdentityPayload),
            success: function (res) {
              $('.xtra-loader-wrapper').fadeOut(500)
              if (res.success) {
                localStorage.removeItem('draft_order_email');
                localStorage.removeItem('draft_order_id');
                redirectToCheckoutOrFallback(res)
              } else {
                console.log(res.error || res.userErrors)
                window.location.href = '/checkout'
              }
            },
            error: function (xhr, status, error) {
              $('.xtra-loader-wrapper').fadeOut(500)
              console.error(error);
              window.location.href = '/checkout'
            },
            complete: function () {
              $('.xtra-loader-wrapper').fadeOut(500)
              $("#xtra-quote-submit").prop("disabled", false);
            }
          });
        });
      }
    });

    /* ---------------------------
      Submit Ask for Quote Form
    ---------------------------- */
    $(document).on('click','#xtra-check-address',function(){
      console.log('working')
      $('#error_lable').html("")
      $('#error_lable').fadeOut(300)
      $('#msg_lable').html("")
      $('#msg_lable').fadeOut(300)
      $(this).prop("disabled", true);
      const email = $("#xtra-quote-email").val().trim();
      const fname = $("#xtra-quote-first-name").val().trim();
      const address1 = $("#xtra-quote-address-line1").val().trim();
      const city = $("#xtra-quote-city").val().trim();
      const province = $("#xtra-quote-state").val().trim();
      const phone = $("#xtra-quote-phone").val().trim();
      const zip = $("#xtra-quote-zip").val().trim();
      const country = "Australia";
      const deliveryTypes = getSelectedDeliveryTypes();
      // const unloadingOption = jQuery('label.xtra-unloading-option-label input[type="radio"]:checked').val()
      // let unloadingValue = ''

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email) {
        $('#error_lable').html("Email address is required.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      }else if(!emailPattern.test(email)){
        $('#error_lable').html("Please enter a valid email address.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      
      }
      if (!fname) {
        $('#error_lable').html("First Name is required.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      }
      if (!zip) {
        $('#error_lable').html("Post Code is required.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      }
      if (!validateDeliveryTypes()) {
        $(this).prop("disabled", false);
        return;
      }
      if(zipCodes.includes(zip)){
        console.log('in GS')
        $('.xtra-loader-wrapper').fadeIn(500)
        let draftOrderId = localStorage.getItem('draft_order_id')
        let draftOrderEmail = localStorage.getItem('draft_order_email')
        clearTimeout(typingTimer);
        clearTimeout(changeTimer);
        clearTimeout(loadingChangeTimer);
        clearTimeout(addressTypingTimer);
        if(draftOrderId){
          $.ajax({
            url: "https://flooring-shipping-app.vercel.app/api/draft-order-delete",
            // url: "https://83a72a5001a2.ngrok-free.app/api/draft-order-delete",
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({id:draftOrderId}),
            success: function (res) {
              if (res.success) {
                  console.log(res)
                  console.log(res.success)
                  localStorage.removeItem('draft_order_email');
                  localStorage.removeItem('draft_order_id');
                  const address = {
                    // address1,
                    // city,
                    // province,
                    first_name:fname,
                    // last_name:lname,
                    zip,
                    country,
                  };
                  $.getJSON("/cart.js", function (cartData) {

                    const line_items = cartData.items.map(function (item) {
                        if(item.line_level_discount_allocations.length > 0){
                          return {
                              variant_id: item.variant_id,
                              quantity: item.quantity,
                              price: item.final_price,
                              applied_discount: {
                                description: item.line_level_discount_allocations[0].discount_application.title,
                                value_type: item.line_level_discount_allocations[0].discount_application.value_type,
                                value: item.line_level_discount_allocations[0].discount_application.value,
                                amount: item.line_level_discount_allocations[0].amount,
                                title: item.line_level_discount_allocations[0].discount_application.title
                              }
                          };
                        }else{
                          return {
                              variant_id: item.variant_id,
                              quantity: item.quantity,
                              price: item.final_price,
                          };
                        }
                    });

                    // Payload
                    const payload = {
                        email,
                        // note: `Unloading Option:${unloadingValue}`,
                        note: '',
                        line_items,
                        shipping_address: address,
                        send_email:false,
                        apply_pickup:false,
                        local_delivery:false
                    };

                    const cartBuyerIdentityPayload = buildCartBuyerIdentityPayload(cartData, {
                      email,
                      phone,
                      firstName: fname,
                      // address1,
                      // city,
                      // provinceCode: province,
                      zip,
                      countryCode: "AU",
                      deliveryMethod: "SHIPPING",
                      note: buildOrderNote(cartData.note, [buildDeliveryTypeNoteLine(deliveryTypes)]),
                    });

                    if (!cartBuyerIdentityPayload) {
                      $('.xtra-loader-wrapper').fadeOut(500)
                      // window.location.href = '/checkout'
                      return;
                    }

                    $.ajax({
                      // url: "https://e290-116-90-106-53.ngrok-free.app/api/cart-buyer-identity-update",
                      url: "https://flooring-shipping-app.vercel.app/api/cart-buyer-identity-update",
                      method: "POST",
                      contentType: "application/json",
                      data: JSON.stringify(cartBuyerIdentityPayload),
                      success: function (res) {
                        $('.xtra-loader-wrapper').fadeOut(500)
                        if (res.success) {
                          redirectToCheckoutOrFallback(res)
                        } else {
                          console.log(res.error || res.userErrors)
                          // window.location.href = '/checkout'
                        }
                      },
                      error: function (xhr, status, error) {
                        $('.xtra-loader-wrapper').fadeOut(500)
                        console.error(error);
                        // window.location.href = '/checkout'
                      },
                      complete: function () {
                        $('.xtra-loader-wrapper').fadeOut(500)
                        $("#xtra-quote-submit").prop("disabled", false);
                      }
                    });
                  });
              } else {
                  // $('.xtra-loader-wrapper').fadeOut(500)
                  console.log(res.error)
                  window.location.href = '/checkout'
              }
            },
            error: function (xhr, status, error) {
                // $('.xtra-loader-wrapper').fadeOut(500)
                console.error(error);
                window.location.href = '/checkout'
            }
          });
        }else{
          const address = {
            // address1,
            // city,
            // province,
            first_name:fname,
            // last_name:lname,
            zip,
            country,
          };
          $.getJSON("/cart.js", function (cartData) {

            const line_items = cartData.items.map(function (item) {
                if(item.line_level_discount_allocations.length > 0){
                  return {
                      variant_id: item.variant_id,
                      quantity: item.quantity,
                      price: item.final_price,
                      applied_discount: {
                        description: item.line_level_discount_allocations[0].discount_application.title,
                        value_type: item.line_level_discount_allocations[0].discount_application.value_type,
                        value: item.line_level_discount_allocations[0].discount_application.value,
                        amount: item.line_level_discount_allocations[0].amount,
                        title: item.line_level_discount_allocations[0].discount_application.title
                      }
                  };
                }else{
                  return {
                      variant_id: item.variant_id,
                      quantity: item.quantity,
                      price: item.final_price,
                  };
                }
            });

            // Payload
            const payload = {
                email,
                // note: `Unloading Option:${unloadingValue}`,
                note: '',
                line_items,
                shipping_address: address,
                send_email:false,
                apply_pickup:false,
                local_delivery:false
            };

            const cartBuyerIdentityPayload = buildCartBuyerIdentityPayload(cartData, {
              email,
              phone,
              firstName: fname,
              address1,
              city,
              provinceCode: province,
              zip,
              countryCode: "AU",
              deliveryMethod: "SHIPPING",
              note: buildOrderNote(cartData.note, [buildDeliveryTypeNoteLine(deliveryTypes)]),
            });

            if (!cartBuyerIdentityPayload) {
              $('.xtra-loader-wrapper').fadeOut(500)
              window.location.href = '/checkout'
              return;
            }

            $.ajax({
              // url: "https://e290-116-90-106-53.ngrok-free.app/api/cart-buyer-identity-update",
              url: "https://flooring-shipping-app.vercel.app/api/cart-buyer-identity-update",
              method: "POST",
              contentType: "application/json",
              data: JSON.stringify(cartBuyerIdentityPayload),
              success: function (res) {
                $('.xtra-loader-wrapper').fadeOut(500)
                if (res.success) {
                  redirectToCheckoutOrFallback(res)
                } else {
                  console.log(res.error || res.userErrors)
                  window.location.href = '/checkout'
                }
              },
              error: function (xhr, status, error) {
                $('.xtra-loader-wrapper').fadeOut(500)
                console.error(error);
                window.location.href = '/checkout'
              },
              complete: function () {
                $('.xtra-loader-wrapper').fadeOut(500)
                $("#xtra-quote-submit").prop("disabled", false);
              }
            });
          });
        }
      }else{
        $('#msg_lable').html("You will receive your custom delivery quote within the next 24 hours. If you need an urgent quote or express delivery, email <a href='mailto:contact@flooringworks.com.au'>contact@flooringworks.com.au</a> or call us on <a href='tel:1800312848'>1800 312 848.</a>")
        $('#msg_lable').fadeIn(300)
        $('#xtra-check-address').fadeOut(500)
        $('#xtra-quote-submit').fadeIn(500)
        $('.xtra-request-quote-specific-fields').slideDown(500)
        console.log('outside of GS')
      }
    })
    $(document).on('click','#xtra-quote-submit', function () {
      $('#error_lable').html("")
      $('#error_lable').fadeOut(300)
      $(this).prop("disabled", true);

      // 1. Get form data
      const first_name = $("#xtra-quote-first-name").val().trim();
      // const last_name = $("#xtra-quote-last-name").val().trim();
      const email = $("#xtra-quote-email").val().trim();
      const phone = $("#xtra-quote-phone").val().trim(); // NEW PHONE FIELD

      const address1 = $("#xtra-quote-address-line1").val().trim();
      // const address2 = $("#xtra-quote-address-line2").val().trim();
      const city = $("#xtra-quote-city").val().trim();
      const province = $("#xtra-quote-state").val().trim();
      const zip = $("#xtra-quote-zip").val().trim();
      const country = "Australia";
      const deliveryTypes = getSelectedDeliveryTypes();
      const unloadingOption = jQuery('label.xtra-unloading-option-label input[type="radio"]:checked').val()
      let unloadingValue = ''

      // Build address with phone included
      

      // -----------------------------
      // VALIDATION
      // -----------------------------

      // Name
      if (!first_name) {
        $('#error_lable').html("First Name is required.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      }

      // Phone
      const phonePattern = /^[0-9\s+\-()]{8,15}$/; 
      if (!phone) {
        $('#error_lable').html("Phone Number is required.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      }else if (!phonePattern.test(phone)) {
        $('#error_lable').html("Please enter a valid phone number (8-15 digits).")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      }

      // Email
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email) {
        $('#error_lable').html("Email address is required.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      }else if(!emailPattern.test(email)){
        $('#error_lable').html("Please enter a valid email address.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      
      }

      if (!validateDeliveryTypes()) {
        $(this).prop("disabled", false);
        return;
      }

      // Address validation
      if (!address1 || !city || !province || !zip) {
        $('#error_lable').html("Complete address is required.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      }
      if(!unloadingOption){
        $('#error_lable').html("Select unloading option.")
        $('#error_lable').fadeIn(300)
        $(this).prop("disabled", false);
        return;
      }else if(unloadingOption == 'Other (please specify):'){
        if(!jQuery('input#xtra-unloading-other').val()){
          $('#error_lable').html("Specify other unloading option.")
          $('#error_lable').fadeIn(300)
          $(this).prop("disabled", false);
          return;
        }else{
          unloadingValue = jQuery('input#xtra-unloading-other').val()

        }
      }else{
        unloadingValue = unloadingOption
      }
      let draftOrderId = localStorage.getItem('draft_order_id')
      let draftOrderEmail = localStorage.getItem('draft_order_email')
      clearTimeout(typingTimer);
      clearTimeout(changeTimer);
      clearTimeout(loadingChangeTimer);
      clearTimeout(addressTypingTimer);
      $('.xtra-loader-wrapper').fadeIn(500)
      if(draftOrderId){
        $.ajax({
          url: "https://flooring-shipping-app.vercel.app/api/draft-order-delete",
          // url: "https://83a72a5001a2.ngrok-free.app/api/draft-order-delete",
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({id:draftOrderId}),
          success: function (res) {
            if (res.success) {
                console.log(res)
                console.log(res.success)
                localStorage.removeItem('draft_order_email');
                localStorage.removeItem('draft_order_id');
                const address = {
                  address1,
                  city,
                  first_name,
                  // last_name,
                  province,
                  zip,
                  country,
                  phone // ADD PHONE TO ADDRESS
                };
  
                // -----------------------------
                // FETCH CART + SEND TO API
                // -----------------------------
                
                $.getJSON("/cart.js", function (cartData) {
          
                    const line_items = cartData.items.map(function (item) {
                        if(item.line_level_discount_allocations.length > 0){
                          return {
                              variant_id: item.variant_id,
                              quantity: item.quantity,
                              price: item.final_price,
                              applied_discount: {
                                description: item.line_level_discount_allocations[0].discount_application.title,
                                value_type: item.line_level_discount_allocations[0].discount_application.value_type,
                                value: item.line_level_discount_allocations[0].discount_application.value,
                                amount: item.line_level_discount_allocations[0].amount,
                                title: item.line_level_discount_allocations[0].discount_application.title
                              }
                          };
                        }else{
                          return {
                              variant_id: item.variant_id,
                              quantity: item.quantity,
                              price: item.final_price,
                          };
                        }
                    });
          
                    // Payload
                    const payload = {
                        email,
                        first_name,
                        // last_name,
                        note: buildOrderNote(cartData.note, [
                          `Quote requested by ${first_name}`,
                          buildDeliveryTypeNoteLine(deliveryTypes),
                          `Unloading Option: ${unloadingValue}`
                        ]),
                        line_items,
                        shipping_address: address,
                        send_email:true,
                        apply_pickup:false,
                        local_delivery:false
                    };
          
                    // Call Draft Order API
                    $.ajax({
                        url: "https://flooring-shipping-app.vercel.app/api/draft-order",
                        // url: "https://e50554ada341.ngrok-free.app/api/draft-order",
                        method: "POST",
                        contentType: "application/json",
                        data: JSON.stringify(payload),
                        success: function (res) {
                            if (res.success) {
                                $.ajax({
                                url: "/cart/clear.js",
                                method: "POST",
                                contentType: "application/json",
                                success: function (ress) {
                                  $('.xtra-loader-wrapper').fadeOut(500)
                                  window.location.href = '/pages/quote-thank-you'
                                },
                                error: function (xhr, status, error) {
                                  $('.xtra-loader-wrapper').fadeOut(500)
                                  $('#error_lable').html("Something went wrong. Contact support.")
                                  $('#error_lable').fadeIn(300)
                                  console.error(error);
                                },
                              }) 
                            } else {
                              $('.xtra-loader-wrapper').fadeOut(500)
                              $('#error_lable').html("Error creating draft order")
                              $('#error_lable').fadeIn(300)
                              console.log(res.error)
                            }
                          },
                        error: function (xhr, status, error) {
                          $('.xtra-loader-wrapper').fadeOut(500)
                          $('#error_lable').html("Something went wrong. Contact support.")
                          $('#error_lable').fadeIn(300)
                          console.error(error);
                        },
                        complete: function () {
                          $('.xtra-loader-wrapper').fadeOut(500)
                            $("#xtra-quote-submit").prop("disabled", false);
                        }
                    });
                });
            } else {
                // $('.xtra-loader-wrapper').fadeOut(500)
                console.log(res.error)
                window.location.href = '/checkout'
            }
          },
          error: function (xhr, status, error) {
              // $('.xtra-loader-wrapper').fadeOut(500)
              console.error(error);
              window.location.href = '/checkout'
          }
        });
      }else{
        const address = {
            address1,
            city,
            first_name,
            // last_name,
            province,
            zip,
            country,
            phone // ADD PHONE TO ADDRESS
        };
  
        // -----------------------------
        // FETCH CART + SEND TO API
        // -----------------------------
        
        $.getJSON("/cart.js", function (cartData) {
  
            const line_items = cartData.items.map(function (item) {
                if(item.line_level_discount_allocations.length > 0){
                  return {
                      variant_id: item.variant_id,
                      quantity: item.quantity,
                      price: item.final_price,
                      applied_discount: {
                        description: item.line_level_discount_allocations[0].discount_application.title,
                        value_type: item.line_level_discount_allocations[0].discount_application.value_type,
                        value: item.line_level_discount_allocations[0].discount_application.value,
                        amount: item.line_level_discount_allocations[0].amount,
                        title: item.line_level_discount_allocations[0].discount_application.title
                      }
                  };
                }else{
                  return {
                      variant_id: item.variant_id,
                      quantity: item.quantity,
                      price: item.final_price,
                  };
                }
            });
  
            // Payload
            const payload = {
                email,
                first_name,
                // last_name,
                note: buildOrderNote(cartData.note, [
                  `Quote requested by ${first_name}`,
                  buildDeliveryTypeNoteLine(deliveryTypes),
                  `Unloading Option: ${unloadingValue}`
                ]),
                line_items,
                shipping_address: address,
                send_email:true,
                apply_pickup:false,
                local_delivery:false
            };
  
            // Call Draft Order API
            $.ajax({
                url: "https://flooring-shipping-app.vercel.app/api/draft-order",
                // url: "https://e50554ada341.ngrok-free.app/api/draft-order",
                method: "POST",
                contentType: "application/json",
                data: JSON.stringify(payload),
                success: function (res) {
                    if (res.success) {
                        $.ajax({
                        url: "/cart/clear.js",
                        method: "POST",
                        contentType: "application/json",
                        success: function (ress) {
                          $('.xtra-loader-wrapper').fadeOut(500)
                          window.location.href = '/pages/quote-thank-you'
                        },
                        error: function (xhr, status, error) {
                          $('.xtra-loader-wrapper').fadeOut(500)
                          $('#error_lable').html("Something went wrong. Contact support.")
                          $('#error_lable').fadeIn(300)
                          console.error(error);
                        },
                      })
                    } else {
                      $('.xtra-loader-wrapper').fadeOut(500)
                      $('#error_lable').html("Error creating draft order")
                      $('#error_lable').fadeIn(300)
                      console.log(res.error)
                    }
                  },
                error: function (xhr, status, error) {
                  $('.xtra-loader-wrapper').fadeOut(500)
                  $('#error_lable').html("Something went wrong. Contact support.")
                  $('#error_lable').fadeIn(300)
                  console.error(error);
                },
                complete: function () {
                  $('.xtra-loader-wrapper').fadeOut(500)
                    $("#xtra-quote-submit").prop("disabled", false);
                }
            });
        });
      }
    });

  });
